export const isLocal = () => process.env.NODE_ENV !== 'production' || process.env.NEXT_PUBLIC_SF_NEXT_LOCAL === 'true';